import React, { FC } from 'react';
import { Props } from './types';
import {
  Container,
  FullStar,
  HalfStar,
  EmptyStar,
  StarsContainer,
} from './styles';

const Rating: FC<Props> = ({ rating }) => {
  const fullStars = Math.trunc(rating);
  const emptyStars = Math.trunc(5 - rating);

  return (
    <Container>
      <StarsContainer>
        {[...Array(fullStars).keys()].map((iterator) => {
          return <FullStar key={iterator} />;
        })}

        {rating % 1 !== 0 ? <HalfStar /> : null}

        {[...Array(emptyStars).keys()].map((iterator) => {
          return <EmptyStar key={iterator} />;
        })}
      </StarsContainer>
      ({rating})
    </Container>
  );
};

export default Rating;
